module.exports = __webpack_public_path__ + "img/mycard.d140798f.png";